export const NUMER_OF_CERTIFICATES_TO_QUERY = 10;
export const SCOPE = 'certificate';
